@if (navigationItems && initialized) {

    <div class="mt-5">

        @if (activeNavigationItem?.action == 'customerBillingTransactionType') {
            <bm-customer-billing-transaction-type-details
                    [customerBillingTransactionTypeId]="objectIdentifier.objectId">
            </bm-customer-billing-transaction-type-details>
        }

        @if (activeNavigationItem?.action == 'billingRunType') {
            <bm-customer-billing-transaction-type-billing-run-types
                    [customerBillingTransactionTypeId]="objectIdentifier.objectId">
            </bm-customer-billing-transaction-type-billing-run-types>
        }

        @if (activeNavigationItem?.action == 'billingRunTypeSepaCharge') {
            <bm-customer-billing-transaction-type-billing-run-type-sepa-charges
                    [customerBillingTransactionTypeId]="objectIdentifier.objectId">
            </bm-customer-billing-transaction-type-billing-run-type-sepa-charges>
        }
    </div>

}
